<script setup lang="ts">
import {Badge} from "@/core/components/ui/badge";
import Icon from "@/core/components/icon/Icon.vue";
import ConsumerProductService from "@/drug-interaction/services/ConsumerProductService";

const {iconColor = 'primary' } = defineProps<{
    index: number;
    product: { name: string };
    iconColor?: string;
}>();
</script>

<template>
  <Badge
    variant="secondary"
    class="shadow-md py-1.5 rounded-full flex leading-tight items-center gap-1 "
    :style="{
      backgroundColor: ConsumerProductService.colorForIndex(index),
    }"
  >
    <Icon name="mdi-pill" :size="15" :color="iconColor" />
    <span class="flex-1 overflow-hidden whitespace-nowrap text-ellipsis">{{ product.name }}</span>
  </Badge>
</template>

<style scoped>

</style>
